module.exports = __webpack_public_path__ + "media/images/client-18-842e6ea711138852a9b7a9b2cba62d2e.png";